import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from "@/views/Login";
import Forgetlogin from "../views/forgetlogin";
import Result from "../views/result"
import SubstationManagement from "../views/HomePageOverview/SubstationManagement"
import Garden from "../views/HomePageOverview/components/garden"
import FirstDiagram from "../views/FirstDiagram"
import CommunicationStatus from "../views/OperatingEnvironment/CommunicationStatus"
import EnvironmentalMonitoring from "../views/OperatingEnvironment/EnvironmentalMonitoring"
import SecurityMonitoring from "../views/OperatingEnvironment/SecurityMonitoring"
import PowerDataHome from "../views/powerMonitor/Index";
import Accident from '../views/accidentManagement/Accident';
import AccidentAnalysis from '../views/accidentManagement/AccidentAnalysis';
import UnconfirmedEvent from '../views/accidentManagement/UnconfirmedEvent';
import MemberManagement from '../views/BusinessAdministration/MemberManagement';
import EnterpriseInformation from '../views/BusinessAdministration/EnterpriseInformation';
import PersonalDetails from '../views/PersonalCenter/PersonalDetails';
import Ammeter from '../views/prepayment/ammeter';
import ElectricityCharge from '../views/prepayment/ElectricityCharge';
import RemoteCopy from '../views/prepayment/remoteCopy';
import EquipmentLedger from "../views/EquipmentLedger/EquipmentLedger";
import ThreeD from "../views/3D"
import store from "../store"
import PVPower from '../views/PV/PVPower';
import PVMonitor from '../views/PV/PVMonitor';
import EnergyEfficiency from "../views/powerMonitor/EnergyEfficiency";
const PowerProfile = ()=>import("../views/HomePageOverview/PowerProfile")
const PtorageSituation = ()=>import("../views/HomePageOverview/PtorageSituation")
const PowerDistribution = ()=>import("../views/HomePageOverview/PowerDistribution")
import BatteryBase from "../views/battery/PowerDataBase"
import ChargingPile from '@/views/ChargingPile/charge'

import DocumentManagement from '../views/EquipmentLedger/DocumentManagement';
import Page404 from "../views/404"
import { projectJump } from "../api/common";
Vue.use(VueRouter)
import {
    disconnect

} from "../mqtt/index";
import SubInverter from "../views/battery/SubInverter";
import Converter from "../views/battery/Converter";
import BatteryHeap from "../views/battery/BatteryHeap2";
import BatteryGroup from "../views/battery/BatteryGroup";
const routes = [

    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: "",

        children: [
            {
                path: '/pvpower',
                name: 'pvpower',
                component: PVPower
            },
            {
                path: '/pvmonitor',
                name: 'pvmonitor',
                component: PVMonitor
            },
            {
                path: '/3D/:page',
                name: '3D',
                component: ThreeD,
                props: true
            },
            {
                path: '/diagram',
                name: 'FirstDiagram',
                component: FirstDiagram
            },
            {
                path: '/communicationStatus',
                name: 'CommunicationStatus',
                component: CommunicationStatus
            },
            {
                path: '/environmentalMonitoring',
                name: 'EnvironmentalMonitoring',
                component: EnvironmentalMonitoring
            },
            {
                path: '/SecurityMonitoring',
                name: 'SecurityMonitoring',
                component: SecurityMonitoring
            },
            {
                path: '/power-data/:name/:tag',
                name: 'PowerDataHome',
                component: PowerDataHome,
                props: true
            },
            {
                path: '/Energy/:name/:tag',
                name: 'EnergyEfficiency',
                component: EnergyEfficiency,
                props: true
            },
            {
                path: '/SubstationManagement',
                name: 'SubstationManagement',
                component: SubstationManagement,
            },
            {
                path: '/ChargingPile',
                name: 'ChargingPile',
                component: ChargingPile,
            },
            // {
            //     path: '/SubstationManagement/PtorageSituation',
            //     name: 'PtorageSituation',
            //     component: PtorageSituation
            // },
            // {
            //     path: '/SubstationManagement/PowerProfile',
            //     name: 'PowerProfile',
            //     component: PowerProfile
            // },
            // {
            //     path: '/SubstationManagement/PowerDistribution',
            //     name: 'PowerDistribution',
            //     component: PowerDistribution
            // },
            {
                path: '/Garden',
                name: 'Garden',
                component: Garden
            },
            {
                path: '/accident/:classify',
                name: 'Accident',
                component: Accident
            },
            {
                path: '/accident-analysis',
                name: 'AccidentAnalysis',
                component: AccidentAnalysis
            },
            {
                path: '/Ammeter',
                name: 'Ammeter',
                component: Ammeter
            },
            {
                path: '/ElectricityCharge',
                name: 'ElectricityCharge',
                component: ElectricityCharge
            },
            {
                path: '/RemoteCopy',
                name: 'RemoteCopy',
                component: RemoteCopy
            },
            {
                path: '/equipment-ledger',
                name: 'EquipmentLedger',
                component: EquipmentLedger
            },
            {
                path: '/document-management',
                name: 'DocumentManagement',
                component: DocumentManagement
            },
            {
                path: '/BatteryBase',
                name: 'BatteryBase',
                component: BatteryBase
            },
            {
                path: '/Unconfirmed-event/:classify',
                name: 'UnconfirmedEvent',
                component: UnconfirmedEvent
            }
        ]
    },
    {
        path: '/admin',
        name: 'Home',
        component: Home,
        redirect: MemberManagement,
        meta: {
            requireAuth: true
        },
        // beforeEach: (to,from, next) => {
        // 	if (to.path == '/') {
        // 		next()
        // 	}

        // 	else {
        // 			console.log(from,"============>")
        // 		next('/login')

        // 	}
        // },
        children: [

            {
                path: '/admin/MemberManagement',
                name: 'MemberManagement',
                component: MemberManagement,

            }, {
                path: '/admin/EnterpriseInformation',
                name: 'EnterpriseInformation',
                component: EnterpriseInformation,

            },
        ],

    },
    {
        path: '/login',
        name: 'Login',
        component: Login,

    },


    {
        path: '/forgetlogin',
        name: 'Forgetlogin',
        component: Forgetlogin
    },
    {
        path: '/result',
        name: 'Result',
        component: Result
    },
    {
        path: '/PersonalDetails',
        name: 'PersonalDetails',
        component: PersonalDetails
    },
    {
        path: '*',
        name: '404',
        component: Page404
    },
]

const router = new VueRouter({
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
    if(to.name=='SubstationManagement'&&to.query.n!= null){
        if (to.query.t != null) {
            store.commit("setToken", to.query.t);
            window.sessionStorage.setItem('token', to.query.t)
        }
        if (to.query.n != null) {
            store.commit("setProjectId", to.query.n);
            projectJump({projectId:to.query.n}).then(res => {
                store.commit("setUser", res.data.data.user);
                store.commit(
                    "setProjectInfo",
                    res.data.data.project
                );
                store.commit("setFirmInfo", res.data.data.firm);
                //判断前后台数据
                store.commit("ForegroundRadio", 1);
                store.commit("webId", null);
                store.commit("NavformDataId", 1);
                sessionStorage.setItem("NavformDataIdch", 1)
                next()
            })
        }
    }else{
        if (store.state.token.isLogin || (to.path === '/login' || to.path === "/forgetlogin" || to.path === "/result")) {
            if (to.path == '/'||to.path == '/admin') {
                disconnect()
                next('/login')
            } else {
                next()
            }
        } else {
            let parse = JSON.parse(sessionStorage.getItem("storech"));

            if (parse && parse.token.isLogin) {
                // console.log("next()---", to.path);
                next()
            } else {
                if (window.sessionStorage.getItem("token")) {
                    parse.token.isLogin = true
                    next()
                } else {
                    disconnect()
                    next("/login")
                    store.commit("clear")
                    sessionStorage.clear()
                }

            }
        }
    }
})

export default router
